(() => {
  const productCache = new Map();

  function formatPrice(cents) {
    const amount = Number(cents) / 100;

    return `$${new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(amount)} MXN`;
  }

  function getProductHandle(link) {
    try {
      const url = new URL(link.href, window.location.origin);
      const parts = url.pathname.split('/').filter(Boolean);
      const productsIndex = parts.indexOf('products');

      if (productsIndex === -1 || !parts[productsIndex + 1]) {
        return null;
      }

      return parts[productsIndex + 1];
    } catch (error) {
      return null;
    }
  }

  async function getProduct(handle) {
    if (!productCache.has(handle)) {
      const root = window.Shopify?.routes?.root || '/';
      const endpoint = `${root}products/${handle}.js`;

      productCache.set(
        handle,
        fetch(endpoint, {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          }
        }).then((response) => {
          if (!response.ok) {
            throw new Error(`Unable to load product: ${handle}`);
          }

          return response.json();
        })
      );
    }

    return productCache.get(handle);
  }

  function getLowestPrice(product) {
    const variants = Array.isArray(product.variants)
      ? product.variants
      : [];

    const availableVariants = variants.filter(
      (variant) => variant.available
    );

    const variantsToUse = availableVariants.length
      ? availableVariants
      : variants;

    const prices = variantsToUse
      .map((variant) => Number(variant.price))
      .filter((price) => Number.isFinite(price));

    if (prices.length) {
      return Math.min(...prices);
    }

    return Number(product.price) || 0;
  }

  function getCompareAtPrice(product, currentPrice) {
    const variants = Array.isArray(product.variants)
      ? product.variants
      : [];

    const matchingVariant = variants.find(
      (variant) =>
        Number(variant.price) === currentPrice &&
        Number(variant.compare_at_price) > currentPrice
    );

    return matchingVariant
      ? Number(matchingVariant.compare_at_price)
      : null;
  }

  function createPriceElement(product) {
    const language =
      document.documentElement.lang?.toLowerCase() || 'en';

    const isSpanish = language.startsWith('es');
    const price = getLowestPrice(product);
    const compareAtPrice = getCompareAtPrice(product, price);

    const wrapper = document.createElement('span');
    wrapper.className = 'article-product-price';

    if (compareAtPrice) {
      const oldPrice = document.createElement('s');
      oldPrice.className = 'article-product-price__compare';
      oldPrice.textContent = formatPrice(compareAtPrice);
      wrapper.appendChild(oldPrice);
    }

    const currentPrice = document.createElement('strong');
    currentPrice.className = 'article-product-price__current';
    currentPrice.textContent = formatPrice(price);
    wrapper.appendChild(currentPrice);

    if (!product.available) {
      const soldOut = document.createElement('span');
      soldOut.className = 'article-product-price__sold-out';
      soldOut.textContent = isSpanish ? 'Agotado' : 'Sold out';
      wrapper.appendChild(soldOut);
    }

    return wrapper;
  }

  async function enhanceProductLink(link) {
    if (link.dataset.articlePriceLoaded === 'true') {
      return;
    }

    if (link.querySelector('img')) {
      return;
    }

    const handle = getProductHandle(link);

    if (!handle) {
      return;
    }

    link.dataset.articlePriceLoaded = 'true';

    try {
      const product = await getProduct(handle);
      const priceElement = createPriceElement(product);

      link.insertAdjacentElement('beforebegin', priceElement);
    } catch (error) {
      link.dataset.articlePriceLoaded = 'error';
      console.warn(error);
    }
  }

  function initializeArticlePrices() {
    const productLinks = document.querySelectorAll(
      'main a[href*="/products/"]'
    );

    productLinks.forEach((link) => {
      if (!link.querySelector('img') && link.textContent.trim()) {
        enhanceProductLink(link);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeArticlePrices
    );
  } else {
    initializeArticlePrices();
  }

  window.addEventListener('load', initializeArticlePrices);
})();